import { mapState } from 'pinia'

import useUserStore from '@/modules/shared/store/useUserStore'
import trackingEvent from '@/modules/shared/utils/tracking_event'

import { STATEMENTDOG_NEWS, PODCAST_EPISODE } from '../constants/feedable_types'

export default {
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useUserStore, ['isSignedIn']),

    relatedStock() {
      return (this.feed.related_stocks && this.feed.related_stocks[0]) || null
    },

    author() {
      return this.feed.author || null
    },

    companyUrl() {
      if (this.relatedStock === null) {
        return null
      }
      return `/analysis/${this.relatedStock.ticker}`
    },

    displayCompanyName() {
      if (this.relatedStock === null) {
        return null
      }
      return this.relatedStock.local_lang_name === ''
        ? this.relatedStock.name
        : this.relatedStock.local_lang_name
    },
  },
  methods: {
    trackClickFeedEvent(element) {
      const eventProperties = this._getEventProperties(element)

      this._sendClickFeedEvent(eventProperties)
      this._sendTrackingEvent(eventProperties)
    },
    _getEventProperties(element) {
      const eventProperties = {
        clickedFrom: window.location.href,
        contentType: this.feed.feedable_type,
        contentTitle: this.feed.title,
        contentSource: this.feed.source_url && new URL(this.feed.source_url).hostname,
        stock: this.relatedStock
          ? [this.relatedStock.ticker, this.relatedStock.name].join(' ')
          : null,
      }

      if (this.feed.feedable_type === PODCAST_EPISODE) {
        eventProperties.contentSource = element.target.innerText.replace('收聽', '').trim()
      }

      return eventProperties
    },
    _sendClickFeedEvent(eventProperties) {
      window.amplitudeEvents.clickFeed(eventProperties)

      if (this.feed.feedable_type === STATEMENTDOG_NEWS) {
        const medium = window.location.pathname === '/feeds'
          ? 'feeds'
          : 'analysis_feeds'
        window.amplitudeEvents.clickStatementdogNews({
          medium,
          title: this.feed.title,
          targetUrl: this.feed.source_url,
        })
      }
    },
    _sendTrackingEvent(eventProperties) {
      if (!this.isSignedIn) { return }

      trackingEvent.clickFeed({
        ...eventProperties,
        feedId: this.feed.feed_id,
        feedableType: this.feed.feedable_type,
        feedableId: this.feed.feedable_id,
        title: this.feed.title,
      })
    },
  },
}
